import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { Tooltip } from 'react-tooltip';
import { QueryClientProvider } from '@tanstack/react-query';

import AuthenticationContextProvider from '@/context/AuthenticateContext';
import TranslateContextProvider from '@/context/TranslateContext';
import { ReactQueryClient } from '@/@core/ReactQuery';
import { store } from '@store/store';
import { App } from './App';

import 'react-tooltip/dist/react-tooltip.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <Provider store={store}>
      <QueryClientProvider client={ReactQueryClient}>
        <TranslateContextProvider>
          <AuthenticationContextProvider>
            <App />
            <Tooltip id="t4tms-tooltip" className="z-[100] !bg-slate-800 font-serif !text-xs" />
          </AuthenticationContextProvider>
        </TranslateContextProvider>
      </QueryClientProvider>
    </Provider>
  </BrowserRouter>,
);
